module.exports = __webpack_public_path__ + "static/ProfilePhoto-b52a238cf53d300810bb8a38c1a9cbf5.jpg";